let Vue

function extend (Vue) {
	Vue.directive('domino', (el, binding) => {
		const content = binding.value.content
		const elem = []
		el.innerHTML = ''
		el.classList.add('domino-effect')
		Array.from(content).forEach((c, i) => {
			let s = document.createElement('span')
			s.classList.add('domino-char')
			s.setAttribute('rel', i)
			s.innerHTML = (c !== ' ') ? c : '&nbsp;'
			el.appendChild(s)
			elem.push(s)
		})

		if (binding.value.active) {
			window.setTimeout(() => { trigger(elem, 0) }, 100)
		}
	})
}

function trigger (elem, i) {
	elem[i].classList.add('active')
	if (i < (elem.length - 1)) {
		window.setTimeout(() => {
			trigger(elem, i + 1)
		}, 100)
	}
}

function _install (_Vue) {
	Vue = _Vue
	extend(Vue)
}

let Domino = function Domino (options = {}) {}

Domino.install = _install
Domino.version = '0.0.1'
export default Domino



// WEBPACK FOOTER //
// ./src/directives/domino.js